export const enum ApiRoutes {
  Auth = '/api/auth',
  ChangePassword = '/api/auth/change-password',
  Session = '/api/auth/session',
  Refresh = '/api/auth/refresh',
  Login = '/api/auth/login',
  Logout = '/api/auth/logout',
  Demo = '/api/auth/demo',
  Signup = '/api/auth/signup',
  ConfirmEmail = '/api/auth/confirm',
  ConfirmCode = '/api/auth/confirm-code',
  ForgotPassword = '/api/auth/forgot',
  SignupStatus = '/api/auth/signup-status',
  LicenseAgreement = '/api/auth/license',

  Chat = '/api/chat',
  NewChat = '/api/chat/new',
  LatestConversation = '/api/chat/conversations/latest',
  Conversations = '/api/chat/conversations',

  Messages = '/api/messages',
  Favorites = '/api/messages/favorites',

  Devotional = '/api/devotional',

  UserProfile = '/api/user-profile',
}
